<i class="far fa-crosshairs" data-fa-symbol="crosshairs"></i>
<i class="far fa-map-marker" data-fa-symbol="map-marker"></i>
<i class="far fa-search" data-fa-symbol="search"></i>
<i class="far fa-sticky-note" data-fa-symbol="notification"></i>

<ng-template #searchTooltip>
  <p>
    {{ 'Search tool' | translate }} (Ctrl+F)
  </p>
  <p>
    {{ 'Trains, locomotives, equipment, traffic control points, stations and addresses' | translate}}
  </p>
</ng-template>

<div class="wrapper" (clickOutside)="onClickedOutside()">
  <div class="d-flex flex-column">
    <div class="d-flex flex-row" style="height: 100%;">
      <div class="search-box">
          <div class="search-box-icon" [ngbTooltip]="searchTooltip" (click)="activateSearchField()">
            <i class="far fa-search fa-lg" style="color: black; font-size: 1.1em;"></i>
          </div>

        <input
          #searchField
          type="text"
          id="test"
          class="search-input"
          style="min-width: 14em;"
          placeholder="{{'Search' | translate}}"
          [(ngModel)]="query"
          qmDebounce
          [delay]="200"
          (onDebounce)="search()"
          (keydown)="onFocusedKeydown($event)"
          [autofocus]="false"
          [qmAutofocus]="false"
        >
      </div>

    </div>
  </div>
  <div class="custom-modal" *ngIf="query?.length > 0">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</div>

<ng-template #content>
  <div class="body">
    <div class="all-result-groups">

      <div class="no-results" *ngIf="!isThereResults()">
        <span>{{'No search results' | translate}}</span>
      </div>

      <!-- Loading status for map layers -->
      <div *ngIf="(notLoadedLayerNames$ | async)?.length > 0">
        <div class="card-header">
          {{'Loading map layers' | translate }}
          <ng-container *ngFor="let layerName of notLoadedLayerNames$ | async | slice:0:3 as names; last as isLast">
            {{ layerName }}{{ isLast ? "" : ","}}
          </ng-container>
          <ng-container *ngIf="(notLoadedLayerNames$ | async)?.length > 3">
            {{ 'and' | translate }} {{ (notLoadedLayerNames$ | async)?.length - 3 }} {{ 'others' | translate }}
          </ng-container>
        </div>
      </div>

      <div #searchResults class="search-results" *ngIf="isThereResults()">
        <div class="d-flex flex-column result-container">
          <div *ngFor="let key of getMapResultKeys()">
            <div class="card card-primary block" *ngIf="getResults(key).results.length > 0">
              <div class="card-header">
                <svg class="svg-inline--fa fa-w-20">
                  <use xlink:href="#map-marker"></use>
                </svg>
                {{ getResults(key).sourceName | translate }}
              </div>
              <ul class="list-group list-group-flush">
                <li *ngFor="let row of getResults(key).results | slice:0:10"
                    [class.active]="
                      getResultId(row) === getResultId(selectedFeature) &&
                      getResults(key).sourceId === $any(selectedFeature).sourceId
                    "
                    class="list-group-item"
                    (click)="selectResultAndCommit(row, getResults(key).sourceId)"
                    (mouseenter)="selectResult(row, getResults(key).sourceId)">
                  {{row.feature.properties[row.feature.layer.metadata.labelBy]}}
                  <span class="search-result-reason" *ngIf="row.reason"> ({{row.reason | translate}})</span>
                </li>
              </ul>
              <div class="card-footer text-muted p-1" *ngIf="getResults(key).results.length > 10">
                {{ 'More results available. Refine search to find them.' | translate }}
              </div>
            </div>
          </div>
          <ng-container *qmAuth="'vivo'">
            <div class="card card-primary block" *ngIf="vivoResults.length > 0">
              <div class="card-header">
                <svg class="svg-inline--fa fa-w-20">
                  <use xlink:href="#map-marker"></use>
                </svg>
                {{'Vivo' | translate}}
              </div>
              <ul class="list-group list-group-flush">
                <li *ngFor="let row of vivoResults"
                    [class.active]="row._id === getResultId(selectedFeature)"
                    class="list-group-item"
                    (click)="selectResultAndCommit(row)"
                    (mouseenter)="selectResult(row)">
                  {{row.name}}
                </li>
              </ul>
            </div>
          </ng-container>
          <ng-container *qmAuth="'notification'">
            <div class="card card-primary block" *ngIf="notificationResults.length > 0">
              <div class="card-header">
                <svg class="svg-inline--fa fa-w-20">
                  <use xlink:href="#notification"></use>
                </svg>
                {{'Notifications' | translate}}
              </div>
              <ul class="list-group list-group-flush notification-list">
                <li *ngFor="let row of notificationResults"
                    [class.active]="row.id.toString() === getResultId(selectedFeature)"
                    class="list-group-item notification-item"
                    (click)="selectResultAndCommit(row)"
                    (mouseenter)="selectResult(row)">
                  <span class="notification-text">
                    {{row.description}}
                  </span>
                  <span class="notification-username">
                    {{row.userName}}
                  </span>
                </li>
              </ul>
            </div>
          </ng-container>
          <div class="card card-primary block" *ngIf="addressResults.length > 0">
            <div class="card-header">
              <svg class="svg-inline--fa fa-w-20">
                <use xlink:href="#map-marker"></use>
              </svg>
              {{'Address' | translate}}
            </div>
            <ul class="list-group list-group-flush">
              <li *ngFor="let row of addressResults"
                  [class.active]="row.description === getResultId(selectedFeature)"
                  class="list-group-item"
                  (click)="selectResultAndCommit(row)"
                  (mouseenter)="selectResult(row)">
                {{row.description}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
